export default "__VITE_ASSET__Ck5sgdpf__"